import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, Formik } from 'formik';
import { Form as FormSemantic } from 'semantic-ui-react';
import _ from 'lodash';
import { InputFormField as Input } from '@playbookux/playbook-web-core';

import schema from './schema';

import {
  MergeButton,
  ContainerHeader,
  ContainerContent,
  ContainerFooter,
  ContainerInputText,
  ContainerListCategories,
  Text,
  TextAlternative,
  TextError,
  Modal,
  Title,
} from './styles';

const ModalMerge = (props) => {
  const {
    onClose,
    onClearCategories,
    selectedCategories,
    createMergedCategory,
  } = props;

  const slicedCategories = useMemo(() => selectedCategories.slice(0, -1), [selectedCategories]);

  const handleCreateMergedCategoryProject = (categoryName, selectedCategoriesIds) => {
    createMergedCategory({
      variables: {
        attributes: {
          name: categoryName,
          mergedCategoriesIds: selectedCategoriesIds,
        },
      },
    });
  };

  const handleMergeCategories = (values) => {
    const categoriesIds = _.map(selectedCategories, (category) => category.id);
    handleCreateMergedCategoryProject(values.name, categoriesIds);
    onClose();
    onClearCategories();
  };

  return (
    <Modal
      open
      onClose={onClose}
      closeOnEscape
      closeOnDimmerClick
    >
      <Formik
        initialValues={{ name: '' }}
        validationSchema={schema}
        onSubmit={handleMergeCategories}
      >

        {({ errors, handleSubmit }) => (
          <FormSemantic onSubmit={handleSubmit}>
            <ContainerHeader>
              <Title as="h1">Merge Categories</Title>
            </ContainerHeader>

            <ContainerContent>
              <ContainerListCategories>
                <Text>{'Merge '}</Text>
                {_.map(slicedCategories, (category, idx) => {
                  if (idx === slicedCategories.length - 1) {
                    return (
                      <TextAlternative key={category.id}>{category.name}</TextAlternative>
                    );
                  }
                  return (
                    <>
                      <TextAlternative>{category.name}</TextAlternative>
                      <Text>{', '}</Text>
                    </>
                  );
                })}
                <Text>{' and '}</Text>
                <TextAlternative>{_.last(selectedCategories).name}</TextAlternative>
              </ContainerListCategories>

              <ContainerInputText>
                <Text marginRight>and create a new category called</Text>
                <FormSemantic.Field>
                  <Field
                    error={errors.name}
                    component={Input}
                    name="name"
                    placeholder="enter new category name"
                  />
                  {errors.name && (
                    <TextError>Enter a new category name</TextError>
                  )}
                </FormSemantic.Field>
              </ContainerInputText>
            </ContainerContent>

            <ContainerFooter>
              <Text>You can unmerge them at any point</Text>
              <MergeButton type="submit">
                Merge
              </MergeButton>
            </ContainerFooter>

          </FormSemantic>
        )}

      </Formik>
    </Modal>
  );
};

ModalMerge.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  onClearCategories: PropTypes.func.isRequired,
  createMergedCategory: PropTypes.func.isRequired,
};

export default ModalMerge;
